module.exports = __webpack_public_path__ + "img/domains-app.d3716894.png";